import { computed } from "vue";
import { useRoute } from "vue-router";
import { gql, DocumentNode } from "@apollo/client/core";
import { useQuery } from "@vue/apollo-composable";

const GET_EXPERT_BY_SLUG = gql`
  query getExpertBySlug($slug: String!) {
    getExpertBySlug(slug: $slug) {
      firstName
      lastName
      uuid
      profilePicture
    }
  }
`;

const GET_PROGRAM_BY_SLUG = gql`
  query getProgramBySlug($slug: String!) {
    getProgramBySlug(slug: $slug) {
      name
      logo
      website
      uuid
    }
  }
`;

export function useSlugQueries() {
  const route = useRoute();

  // Check if we're using slug-based routing
  const isSlugBasedRoute = computed(() => {
    return route.params.programSlug && route.params.expertSlug;
  });

  // Helper function to create slug-based queries
  const createSlugQuery = (paramName: string, query: DocumentNode) => {
    const slug = computed(() => route.params[paramName] as string);
    const { result } = useQuery(
      query,
      () => ({ slug: slug.value }),
      () => ({ enabled: !!(slug.value && isSlugBasedRoute.value) })
    );
    return { slug, result };
  };

  // Create expert and program queries using the helper
  const expert = createSlugQuery("expertSlug", GET_EXPERT_BY_SLUG);
  const program = createSlugQuery("programSlug", GET_PROGRAM_BY_SLUG);

  return {
    isSlugBasedRoute,
    expertSlug: expert.slug,
    programSlug: program.slug,
    expertBySlugResult: expert.result,
    programBySlugResult: program.result,
  };
}
